import {
  type OfferDetailsV11,
  type OfferRedPointsV1,
  type OfferV11,
} from '@redteclab/api/clients/bully'

const cartIntermediateAccessorGetCurrentTimeIsInRedpointsTimeframe = (
  redPoints: OfferRedPointsV1,
): boolean => {
  const endDate = new Date(redPoints.endDate ?? 0).getTime()
  const startDate = new Date(redPoints.startDate ?? 0).getTime()
  const now = Date.now()

  const noEndDateAndNowIsAfterStart = endDate === 0 && now > startDate

  if (noEndDateAndNowIsAfterStart) {
    return true
  }

  const noStartDateAndNowIsBeforeEnd = startDate === 0 && endDate > now

  if (noStartDateAndNowIsBeforeEnd) {
    return true
  }

  return now >= startDate && now <= endDate
}

/**
 * shortcut to get the redpoints object from offer
 */
const cartIntermediateAccessorGetRedPointsForOffer = (
  offer: OfferDetailsV11 | OfferV11,
): OfferRedPointsV1 | undefined => {
  return offer.offerPrice?.additionalInformation?.redPoints ?? undefined
}

/**
 * returns redpoints multiplier
 * defaults to 0 if less than 1 (in legacy code it could be e.g. -1)
 */
const cartIntermediateAccessorGetRedPointsMultiplier = (
  redPoints: OfferRedPointsV1,
): number => {
  const multiplier = redPoints.multiplier ?? 0
  if (multiplier < 1) {
    return 0
  }

  return multiplier
}

const cartIntermediateAccessorGetRedPointsAmountWithoutMultiplier = (
  redPoints: OfferRedPointsV1,
): number => {
  return redPoints.amount ?? 0
}

export const cartIntermediateAccessorGetRedPointsRedPointsAmountWithMultiplier =
  (offer: OfferDetailsV11 | OfferV11): number => {
    // the multiplier is applied in the backend, just checking the rest of conditions
    const redPoints = cartIntermediateAccessorGetRedPointsForOffer(offer)
    if (!redPoints) {
      return 0
    }

    const amount =
      cartIntermediateAccessorGetRedPointsAmountWithoutMultiplier(redPoints)
    const multiplier = cartIntermediateAccessorGetRedPointsMultiplier(redPoints)

    if (multiplier < 1) {
      return 0
    }

    if (
      !cartIntermediateAccessorGetCurrentTimeIsInRedpointsTimeframe(redPoints)
    ) {
      return amount / multiplier
    }

    return amount
  }
